import React from "react";
import { FormattedMessage } from "react-intl";

export const ExternalCheckoutPaymentTypesMapping = {
    'alipay': <FormattedMessage
        id="payment.payment_type.alipay"
        defaultMessage="Alipay"
    />,
    'bancontact': <FormattedMessage
        id="payment.payment_type.bancontact"
        defaultMessage="Bancontact"
    />,
    'ideal': <FormattedMessage
        id="payment.payment_type.ideal"
        defaultMessage="iDEAL"
    />,

    'acss_debit': <FormattedMessage
        id="payment.payment_type.acss_debit"
        defaultMessage="Canadian PADs"
    />,
    'afterpay_clearpay': <FormattedMessage
        id="payment.payment_type.afterpay_clearpay"
        defaultMessage="Afterpay / Clearpay"
    />,
    'bacs_debit': <FormattedMessage
        id="payment.payment_type.bacs_debit"
        defaultMessage="Bacs Direct Debit"
    />,
    'boleto': <FormattedMessage
        id="payment.payment_type.boleto"
        defaultMessage="Boleto"
    />,
    'eps': <FormattedMessage
        id="payment.payment_type.eps"
        defaultMessage="EPS"
    />,
    'fpx': <FormattedMessage
        id="payment.payment_type.fpx"
        defaultMessage="FPX"
    />,
    'giropay': <FormattedMessage
        id="payment.payment_type.giropay"
        defaultMessage="giropay"
    />,
    'grabpay': <FormattedMessage
        id="payment.payment_type.grabpay"
        defaultMessage="GrabPay"
    />,
    'oxxo': <FormattedMessage
        id="payment.payment_type.oxxo"
        defaultMessage="OXXO"
    />,
    'p24': <FormattedMessage
        id="payment.payment_type.p24"
        defaultMessage="P24"
    />,
    'sepa_debit': <FormattedMessage
        id="payment.payment_type.sepa_direct_debit"
        defaultMessage="SEPA Direct Debit"
    />,
    'sofort': <FormattedMessage
        id="payment.payment_type.sofort"
        defaultMessage="Sofort"
    />,
    'wechat_pay': <FormattedMessage
        id="payment.payment_type.wechat_pay"
        defaultMessage="WeChat Pay"
    />,
}

export const ExternalPaymentTypesMapping =
{
    'bank-transfer': <FormattedMessage
        id="payment.tab.bank_transfer"
        defaultMessage="Bank Account"
    />,
    'credit-card': <FormattedMessage
        id="payment.tab.credit_card"
        defaultMessage="Credit Card"
    />,
    ...ExternalCheckoutPaymentTypesMapping,
}


// WEBPACK FOOTER //
// ./src/payment/externalpaymenttypesmapping.jsx